import { render, staticRenderFns } from "./PostTime.vue?vue&type=template&id=1fea7bc6&scoped=true&"
import script from "./PostTime.vue?vue&type=script&lang=js&"
export * from "./PostTime.vue?vue&type=script&lang=js&"
import style0 from "./PostTime.vue?vue&type=style&index=0&id=1fea7bc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fea7bc6",
  null
  
)

export default component.exports